export default __webpack_public_path__ + "static/media/Vitae_Contact.d3317c75.png";